export const tableHead = [
  { key: 'number', value: '№', valueEN: '№', isActive: true },
  { key: 'fio', value: 'ФИО', valueEN: 'Full Name', isActive: true },
  { key: 'organization', value: 'Организация', valueEN: 'Organization', isActive: true },
  { key: 'direction', value: 'Направление', valueEN: 'Direction', isActive: true },
  { key: 'name', value: 'Доклад', valueEN: 'Report', isActive: true },
];

export const tableHeadAdmin = [
  { key: 'number', value: '№', valueEN: '№', isActive: true },
  { key: 'fio', value: 'ФИО', valueEN: 'Full Name', isActive: true },
  { key: 'organization', value: 'Организация', valueEN: 'Organization', isActive: true },
  { key: 'status', value: 'Участие', valueEN: 'Participation', isActive: true },
  { key: 'direction', value: 'Направление', valueEN: 'Direction', isActive: true },
  { key: 'name', value: 'Доклад', valueEN: 'Report', isActive: true },
];
